import { render, staticRenderFns } from "./PhoNumber.vue?vue&type=template&id=328475e1&lang=pug"
import script from "./PhoNumber.vue?vue&type=script&lang=js"
export * from "./PhoNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports